// extracted by mini-css-extract-plugin
export default {"qr":"attendance-qr_qr__yAiYK","noSelection":"attendance-qr_noSelection__18ePk"};